import PageTemplate from "@/components/templates/PageTemplate";
import DefaultMd from "@/components/legals/DefaultMd";
import React from "react";
import { getMd } from "@/Service.server";
import { serverSideTranslations } from "@/libs/i18n/serverSideTranslations";

type Props = {
  md: any;
};

const QuestPrivacyPolicy = ({ md }: Props) => {
  return (
    <PageTemplate>
      {/* 정적 프리렌더 — 띠의 시각 판정을 요청 시각에 못 한다 (#5655 R3 x1). */}
      <PageTemplate.Content hidePromoBanner>
        <DefaultMd md={md} />
      </PageTemplate.Content>
    </PageTemplate>
  );
};

export const getStaticProps = async ({ params, locale }) => {
  let md = {};
  try {
    md = getMd("src/mds/legals", "quest-privacy-policy");
  } catch (e) {}
  return {
    props: {
      md,
      ...(await serverSideTranslations(locale, ["gnb"])),
    },
  };
};

export default QuestPrivacyPolicy;
